import React from 'react';
import SSR from './SSR';

export default function () {
    return <SSR />;
}
